<template>
	<ul id="metalist">
		<li>
			<v-row>
				<v-col cols="4">
					<v-text-field type="text" v-model="newmeta.name" outlined name="newmetaname" id="newmetaname"
						placeholder="属性名" style="width: 100px; display: inline" />
				</v-col>
				<v-col cols="4">
					<v-text-field type="text" v-model="newmeta.value" outlined name="newmetavalue" id="newmetavalue"
						placeholder="属性值" style="width: 200px; display: inline" />
				</v-col>
				<v-col cols="4" class="d-flex justify-start">
					<v-btn color="primary" @click="add"><v-icon>$plus</v-icon></v-btn>
				</v-col>
			</v-row>
		</li>

		<li v-for="meta in metas">
			<span>{{ meta.name }}:{{ meta.value }}</span>
			<v-btn color="warning" small text @click="edit(meta)">
				<v-icon small>$edit</v-icon></v-btn>
			<v-btn color="error" small text @click="remove(meta.name, meta.value)">
				<v-icon small>$remove</v-icon>
			</v-btn>
		</li>
	</ul>
</template>
<script>
export default {
	props: {
		initMetas: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			metas: [],
			newmeta: {}
		}
	},
	mounted() {
		this.metas = this.initMetas ? this.initMetas : []
	},
	methods: {
		remove(n, v) {
			let exists = this.metas.findIndex((e) => {
				return e.name == n && e.value == v
			})
			console.log('foundmeta', exists)
			if (exists >= 0) {
				this.metas.splice(exists, 1)
				this.$emit('changed', this.metas)
			}
		},
		edit(meta) {
			this.newmeta = meta
		},
		add() {
			let result = this.addEx(this.newmeta)
			if (result) {
				this.newmeta = {}
			}
		},
		addEx(e) {//外部调用
			if (!e.name || !e.value) {
				alert('请填写属性名称和值')
				return false
			}
			let exists = this.metas.findIndex((ele) => {
				return (
					e.name === ele.name &&
					e.value === ele.value
				)
			})
			if (exists >= 0) return false

			this.metas.push(e)
			this.$emit('changed', this.metas)
			return true
		}
	}
}
</script>
